import { gql } from '../types/generated';

export const UPDATE_PIPELINE_INPUT_CONFIG =
  gql(`mutation updatePipelineInputConfig($venueId: Int!, $feedType: MediaFeedType!, $pipelineInputConfig: PipelineInputConfig, $region: Region) {
    updatePipelineInputConfig(venueId: $venueId, feedType: $feedType, pipelineInputConfig: $pipelineInputConfig, region: $region) {
      venueId
      feedTypeCode
      id
      inputLabel
      category
      region
    }
  }`);
